import { OrganisationModel, SubdomainModel } from 'back-end/src/models/dbModels'
import { IImageVariant } from './CoverImage'

export const isSingleIP = (
  record: OrganisationIPWhitelistRecord
): record is IOrganisationIPWhitelistSingle => 'ip' in record

export const organisationWhitelistRecordToType = (
  record: OrganisationIPWhitelistRecord
): OrganisationIPWhitelistTypeEnum => {
  if (isSingleIP(record)) {
    return OrganisationIPWhitelistTypeEnum.Single
  }
  return OrganisationIPWhitelistTypeEnum.Range
}

export enum OrganisationIPWhitelistTypeEnum {
  Single,
  Range
}

export enum OrganisationRoleEnum {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  STUDENT = 'STUDENT'
}

export const adminAndManagerOrganisationRoles = [
  OrganisationRoleEnum.ADMIN,
  OrganisationRoleEnum.MANAGER
]

export interface IOrganisationIPWhitelistRange {
  from: string
  to: string
}

export interface IOrganisationIPWhitelistSingle {
  ip: string
}

export type OrganisationIPWhitelistRecord =
  | IOrganisationIPWhitelistSingle
  | IOrganisationIPWhitelistRange

export type OrganisationIPWhitelist = OrganisationIPWhitelistRecord[]

export interface IOrganisationLogo {
  original?: string | null
  variants?: IImageVariant[] | string[]
}

export interface IOrganisationWhitelistFoundDomains {
  [key: string]: string[]
}

export interface IOrganisationNotifications {
  sms?: boolean
  slack?: {
    organisation_access_token?: string
    slack_access_token?: string
  }
  msteams?: boolean
}

export interface IOrganisationGSuite {
  calendar?: boolean
  drive?: boolean
  driveServiceAccount?: boolean
  linkedResourcesDriveId?: string
}

export type OrganisationGSuite = IOrganisationGSuite

export interface IOrganisationColor {
  name: string
  color: string
}

export interface IOrganisationFontConfig {
  fontName: string
  baseFontSize: string
  headerFontWeight: string
  WebFontConfig: {
    custom: {
      families: string[]
      urls: string[]
    }
  }
}

export type OrganisationModelWithSubdomain = OrganisationModel & {
  subdomain: SubdomainModel
}

export interface ICustomSMTPConfigurationInput {
  host: string
  port: number
  user: string
  pass: string
}

export interface ICustomSMTPConfiguration
  extends ICustomSMTPConfigurationInput {
  validated_at: Date | null
}

export interface ICustomSMTPMailFrom {
  name: string
  email: string
  verified_at?: Date | null
}
